import { createFileRoute } from '@tanstack/react-router'
import CompanyPage from "../../../components/Companies/CompanyPage.tsx";

export const Route = createFileRoute('/_layout/company/$companyId')({
  component: CompanyPage,
})
